// extracted by mini-css-extract-plugin
module.exports = {"pin":"e_Y9","pinOn":"e_Z9","icon":"e__9","tile":"e_09","iconOnly":"e_19","label":"e_29","tileSub":"e_39","tileNames":"e_49","tileGo":"e_59"};